import { render, staticRenderFns } from "./DisabledDiscounts.vue?vue&type=template&id=1cc4a120&scoped=true&"
import script from "./DisabledDiscounts.vue?vue&type=script&lang=js&"
export * from "./DisabledDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./DisabledDiscounts.vue?vue&type=style&index=0&id=1cc4a120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4a120",
  null
  
)

export default component.exports